import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import {
  Drawer,
  Button,
  Form,
  notification,
  Select,
  Upload,
} from "antd";
import { InboxOutlined } from "@ant-design/icons";
const Context = React.createContext({
  name: "Default",
});
const onSearch = (value) => {
};
const StepForm = forwardRef((props, ref) => {
  const [visible, setVisible] = useState(false); // Track drawer visibility
  const { Dragger } = Upload;

  // Expose methods to the parent component
  useImperativeHandle(ref, () => ({
    openDrawer: () => {
      setVisible(true); // Open drawer
    },
    closeDrawer: () => {
      setVisible(false); // Close drawer
    },
  }));
  const [api, contextHolder] = notification.useNotification();
  const openNotification = (placement) => {
    api.success({
      message: `Success`,
      description: (
        <Context.Consumer>
          {({ name }) => `Successfully Saved`}
        </Context.Consumer>
      ),
      placement,
    });
  };
  const contextValue = useMemo(
    () => ({
      name: "Ant Design",
    }),
    []
  );

  return (
    <Context.Provider value={contextValue}>
      {contextHolder}
      <Drawer
        title="Upload Document"
        width={700}
        visible={visible}
        onClose={() => setVisible(false)}
        footer={
          <div style={{ textAlign: "right" }}>
            <Button style={{ marginRight: 8 }} size="large">
              Clear
            </Button>

            <Button
              type="primary"
              size="large"
              onClick={() => openNotification("topRight")}
            >
              Upload
            </Button>
          </div>
        }
      >
        <div style={{ marginTop: 24 }}>
          <Form layout="vertical">
            <Form.Item
              label="Transaction Type"
              name="state"
              rules={[
                { required: true, message: "Transaction Type is required" },
              ]}
            >
              <Select
                showSearch
                placeholder="Select Template Type"
                optionFilterProp="label"
                // onChange={onChange}.
                size="large"
                onSearch={onSearch}
                options={[
                  {
                    value: "Transaction 1",
                    label: "Transaction 1",
                  },
                  {
                    value: "Transaction 2",
                    label: "Transaction 2",
                  },
                ]}
              />
            </Form.Item>

            <Form.Item
              label="File"
              name="file"
              rules={[{ required: true, message: "File is required" }]}
            >
              <Dragger {...props}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag Excel file of PDF to this area to upload
                </p>
                <p className="ant-upload-hint">
                  Support for a single file upload.
                </p>
              </Dragger>
            </Form.Item>
          </Form>
        </div>
      </Drawer>
    </Context.Provider>
  );
});

export default StepForm;
